import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {DataCacheApiService} from '../../../services/map/data-cache-api/data-cache-api.service';
import {MetaDataService} from '../../../../services/metaData/meta-data.service';
import * as _ from 'lodash';

@Component({
  selector: 'offline-peer-connection-summary',
  templateUrl: './offline-peer-connection-summary.component.html',
  styleUrls: ['./offline-peer-connection-summary.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class OfflinePeerConnectionSummaryComponent implements OnInit {

  @Input()
  set selection(selection: any) {
    this.dataInitialization(selection);
  }

  constructor(private metaDataService: MetaDataService,
              private dataCacheApiService: DataCacheApiService) {
  }

  peerConnection: any;
  isQualityEnabled: boolean;

  topologyGroups = '';

  ngOnInit(): void {
    this.dataCacheApiService.getDataReady().subscribe(x => {
      if (x === true) {
        this.initializeQualityBasedRoutingConfigurations();
      }
    });
  }

  initializeQualityBasedRoutingConfigurations(): void {
    this.isQualityEnabled = this.dataCacheApiService.getQualityBasedRouting().isQualityEnabled;
  }

  generateAdministrativeStateLabel(): string {
    return this.metaDataService.PeerConnectionAdminStatus[this.peerConnection.adminState].label;
  }

  initializeData(): void {
    this.topologyGroups = _.isEmpty(this.peerConnection.topologyGroups) ? '' :
        this.peerConnection.topologyGroups.map(group => group.name).join(', ');
  }

  private dataInitialization(selection: any): void {
    if (_.isNil(selection)) { return; }

    const shapes = selection.nodes;
    const connections = selection.edges;
    if (shapes.length === 0 && connections.length === 1 && connections[0].connectionType === 'peerConnection') {
      this.peerConnection = connections[0].dataItem;
      this.initializeData();
    }
  }
}
